import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: 0,
        margin: 0,
        backgroundColor: "#FFFFFF",
        fontFamily: "Lato",
        '& .MuiFormHelperText-root': {
            '&.Mui-error': {
                color: "red",
            },
        },
        '& .MuiFormHelperText-contained': {
            margin: "0px !important",
        },
    },
    //offset: theme.mixins.toolbar,
    
    yellowBtn: {
        background: "#F4C145",
        color: "#00142E",
        padding: "6px 16px",
        //fontSize: "18px",
        fontSize:16,
        fontWeight: 700,
        borderRadius: 4,
        minWidth: 0,
        // width:"200px",
        // height:"50px",
        // marginTop:"10px",
        '&:hover': {
            backgroundColor: "#F4C145",
            color: "#00142E",
        },
        '&.small': {
           // fontSize: "9pt",
           fontSize:14
        },
    },
    whiteBtn: {
        background: "#EFF0F2",
        color: "#03090E",
        padding: "6px 16px",
        fontSize: 16,
        fontWeight: 700,
        borderRadius: 4,
        minWidth: 0,
        '&:hover': {
            backgroundColor: "#EFF0F2",
            color: "#00142E",
        },
    },
    
    thankYouMain: {
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
    textAlign: "center",
    "& .icon": {
            padding: theme.spacing(3, 0),
      "& img": {
                height: "66px",
            },
        },
    "& .text1": {
            fontSize: 40,
            fontWeight: 900,
      color: "#04142e",
      [theme.breakpoints.down("sm")]: {
        fontSize: "30px",
        },
    },
    "& .text2": {
            fontSize: 20,
            fontWeight: 400,
            margin: theme.spacing(2, 0, 4, 0),
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
        },
    },
    "& .paragraph": {
            fontSize: "24px",
            color: "#04142e",
            fontFamily: "Lato",
            //fontWeight: 400,
      marginTop: "20px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
          },
    },
  },
    
    // list page
    pcrListEmptyMain: {
        //minHeight: "90vh",
        minHeight: "calc(100vh - 60px)",
        alignItems: "center",
        justifyContent: "center",
        textAlign: 'center',
        '& .line1': {
            fontSize: 20,
            fontWeight: 400,
        },
        '& .line2': {
            fontSize: 14,
            fontWeight: 400,
            margin: theme.spacing(1, 0, 5, 0),
            color: "rgba(0, 20, 46, 0.5)",
        },
    },
    pcrListMain: {
        padding: 0,
        margin: 0,
    },
    pcrListHeader: {
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: "#FFFFFF",
        padding: theme.spacing(3),
        margin: 0,
        alignItems: "center",
        '&#pcrFixedTop': {
            width: "100%",
            maxWidth: "100vw",
            position: "fixed",
            top: "59px",
            left: 0,
            right: 0,
            zIndex: 1200,             
       },
        '& .text1': {
            fontSize: 16,
            fontWeight: 400,
        },
    },
    pcrListSection: {
        width: "100%",
        padding: theme.spacing(1, 3, 3, 3),
        margin: 0,
        marginTop: "82px",
    },
    pcrListItem: {
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: "#EFF0F2",
        padding: theme.spacing(4, 2),
        alignItems: "center",
        borderRadius:"4px",
        '& .icon': {
            //height: "50px",
        },
        '& .title': {
            width: "100%",
            fontSize: 22,          
            fontWeight: 900,
            padding: theme.spacing(1, 0),
            color:"#00479d",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        '& .desc': {
            fontSize: 14,
            fontWeight: 400,
            color: "rgba(0, 20, 46, 0.5)",
        },
    },
    
    // add form
    pcrAddHeader: {
        width: "100%",
        margin: 0,
        padding: 0,
        '&#pcrFixedTop': {
            width: "100%",
            maxWidth: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: "#FFFFFF",
            zIndex: 1200,
        },
        '& .errorMsg': {
            width: "100%",
            position: "fixed",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#D56C6A",
            color: "#FFFFFF",
            padding: theme.spacing(2.5),
            zIndex: 1500,
            '& .text': {
                fontSize: 14,
                fontWeight: 700,
            },
            '& .icon': {
                cursor: "pointer",
            },
        },
    },
    pcrAddNavbar1: {
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#00142E",
        margin: 0,
        padding: theme.spacing(0.5, 1),
        '& button': {
            //margin: 0,
        },
        '& img': {
            //height: "14px",
        },
        '& #formStatus': {
            color: "#469B52",
        },
    },
    pcrAddNavbar2: {
        justifyContent: "space-between",
        alignItems: "flex-start",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        //borderBottom: "2px solid #E0E0E0",
        borderBottom: 0,
        boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2)",
        '& .MuiTabs-root': {
            //height: "48px",
            '& .MuiTabs-indicator': {
                display: "none",
            },
        },
        '& .MuiTabs-flexContainer': {
            alignItems: "center",
        },
        '& .MuiTab-root': {
            minWidth: 0,
            width: "48px",
            //height: "48px",
            '&.Mui-selected': {
                background: "#F4C145",
                borderBottom: 0,
            },
        },
    },
    submitBtn: {
        width: "100%",
        height: "48px",
        background: "#F4C145",
        color: "#00142E",
        margin: 0,
        padding: "0px 18px",
        fontSize: "14px",
        fontWeight: 700,
        minWidth: 0,
        borderRadius:"0",
        '&:hover': {
            background: "#F4C145",
            color: "#03090E",
        },
        '& img': {
            paddingRight: "7px",
        },
    },
    pcrAddBody: {
        margin: "100px 0 0 0",
        padding: 0,
    },
    pcrAddTabItem: {
        scrollMarginTop: "100px",
        padding: theme.spacing(5, 5),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(3, 3),
        },
        '&.noSpaing': {
            margin: 0,
            padding: 0,
        },
    },
    pcrAddHeading: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
        fontSize: 40,
        fontWeight: 900,
        color: "#00142E",
        [theme.breakpoints.down("xs")]: {
            fontSize: 22,
        },
        '& span': {
            fontSize: 14,
            fontWeight: 600,
            '&::before': {
                content: '"* "',
                fontSize: 24,
                color: "#F4C34C",
                verticalAlign: "text-top",
            },
        },
    },
    pcrAddFormTypes: {
        justifyContent: "center",
        alignItems: "stretch",
        border:"1px solid #e0e0e0",
        borderRadius:"4px",
        margin: theme.spacing(5, 0, 0, 0),
        [theme.breakpoints.only("xs")]: {
            margin: theme.spacing(3, 0, 0, 0),
        },
        '& .MuiGrid-item': {
            '& .item': {
                height: "100%",
                cursor: "pointer",
                borderRadius: 4,
                padding: 0,
                margin: 0,
                '&.selected': {
                    cursor: "default",
                    backgroundColor: "#F9E0A2",
                },
                '& .content': {
                    color: "#031630",
                    textAlign: "center",
                    padding: theme.spacing(2, 1.5),
                    fontWeight: 600,
                    fontSize: 15,
                    [theme.breakpoints.only("xs")]: {
                        fontSize: 14,
                    },
                    '& img': {
                        height: "23px",
                        marginBottom: theme.spacing(1),
                    },
                    '& span': {
                        display: "block",
                        color: "#00479D",
                        textTransform: "uppercase",
                        fontSize: 14,
                        [theme.breakpoints.only("xs")]: {
                            fontSize: 12,
                        },
                    },
                },
            },
        },
    },
    
    pcrAddTabHeading: {
        fontSize: 21,
        fontWeight: 900,
        paddingBottom: theme.spacing(3),
        color: "#00479D",
        textTransform: "uppercase",
    },
    
    formContainer: {
        '& .MuiFormControlLabel-label': {
            fontSize: 16,
            fontWeight: 500,
        },
        '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
            fontSize: 16,
            fontWeight: 600,
            backgroundColor: "#EFF0F2",
            color: "#00122A",
            height: "44px",
            width: "100%",
            borderRadius: "4px",
        },
    },
    helperText: {
        color: 'red',
        //padding: theme.spacing(0, 0, 0, 2),
    },
    formControlLabel: {
        fontSize: 14,
        fontWeight: 600,
        color: "#00122A",
        padding: theme.spacing(0, 0, 1, 0),
        '&.bold': {
            fontWeight: 700,
        },
        '& .incident': {
            float: "right",
            color: "#DF5151",
        },
    },
    textFieldRoot: {
        //width: "100%",
    },
    frame: {
        backgroundColor: "#f6f6f6",
        borderRadius: "5px",
        height: "100px",
    maxWidth: "290px",
    marginTop: "28px",
        alignItems: "center",
        justifyContent: "center",
    padding: "15px",
        margin: "0 auto", // horizontally center
    textAlign: "center",
    },  
    downloadCode: {
        fontSize: "14px",
        color: "#04142e",
        fontFamily: "Lato",
        fontWeight: "bold",
        textTransform: "uppercase",
        //marginTop:"20px",
    },
    downloadCodeno: {
        fontSize: "36px",
        color: "#04142e",
        fontFamily: "Lato",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing:"15px",
        paddingTop:"20px",
    },
    checkboxs: {
        fontSize: "18px",
        color: "#04142e",
        fontFamily: "Lato",
        fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    paddingInline: "15px",
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      "& .MuiTypography-root": {
        fontSize: "14px",
      },
    },
        //textTransform: "uppercase",
        //marginTop:"10px",
    },
    checkboxInput: {
        '&.MuiCheckbox-root': {
            '&:not(.Mui-checked) .MuiIconButton-label:after': {
                backgroundColor: "#EFF0F2",
            },
            '& .MuiIconButton-label svg.MuiSvgIcon-root': {
                fill: "#EFF0F2",
            },
            '&.whiteBg': {
                '&:not(.Mui-checked) .MuiIconButton-label:after': {
                    backgroundColor: "#FFFFFF",
                },
                '& .MuiIconButton-label svg.MuiSvgIcon-root': {
                    fill: "#FFFFFF",
                },
            },
        },
    },
    textFieldInput: {
        fontSize: 16,
        fontWeight: 600,
        backgroundColor: "#EFF0F2",
        color: "#00122A",
        height: "44px",
        width: "100%",
        borderRadius: "4px",
        '& .clickable': {
            cursor: "pointer",
        },
    },
    multilinetextFieldInput: {
        fontSize: 16,
        fontWeight: 600,
        backgroundColor: "#EFF0F2",
        color: "#00122A",
        height: "100%",
        width: "100%",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderRadius: "4px",
    },
    selectField: {
        fontSize: 16,
        fontWeight: 600,
        backgroundColor: "#EFF0F2",
        height: "44px",
        width: "100%",
        borderRadius: "4px",
        '& .MuiSelect-selectMenu': {
            fontSize: 16,
            fontWeight: 600,
        },
        '& img': {
            paddingRight: "15px",
        },
    },
    buttonSwitchField: {
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 16,
        fontWeight: 500,
        color: "#00142E",
        width: "100%",
        '& .thin': {
            fontWeight: 200,
        },
        '& button': {
            cursor: "pointer",
            background: "#EFF0F2",
            color: "#000000",
            fontSize: 14,
            fontWeight: 200,
            padding: "8px 16px",
            borderRadius: "4px",
            border: 0,
            '&:nth-child(odd)': {
                marginRight: "4px",
            },
            '&.selected': {
                cursor: "default",
                background: "#000000",
                color: "#EFF0F2",
                '&.custom1': {
                    background: "#DF5151",
                },
            },
        },
    },
    backgroundSwitches: {
        [theme.breakpoints.up("md")]: {
            '& .MuiGrid-item.leftside': {
                paddingRight: "20px",
            },
            '& .MuiGrid-item.rightside': {
                paddingLeft: "20px",
            },
        },
    },
    backgroundSwitchItem: {
        padding: theme.spacing(0.15, 0),
        borderBottom: "1px solid #eff0f2",
        marginBottom:"3px",
    },
    allergiesFormList: {
        justifyContent: "flex-start",
        alignItems: "center",
        paddingBottom: theme.spacing(3),
        '& .removeBtn': {
            cursor: "pointer",
            position: "absolute",
            right: "5px",
        },
        '& .MuiGrid-item': {
            padding: "0.03rem 4px",
            '&.gridtop .MuiOutlinedInput-root': {
                borderRadius:"4px 4px 0 0",
            },
            '&.gridbottom .MuiOutlinedInput-root': {
                borderRadius:"0 0 4px 4px",
            },
        },
        '& .gridtop': {
            position: "relative",
        },
        '& .gridbottom': {
            //position: "relative",
        },
        '& .reaction': {
            fontSize: 14,
            fontWeight: 600,
            color: "#798391",
            paddingRight: theme.spacing(1),
        },
    },
    assessmentSwitches: {
        [theme.breakpoints.up("md")]: {
            '& .MuiGrid-item.leftside': {
                paddingRight: "20px",
            },
            '& .MuiGrid-item.rightside': {
                paddingLeft: "20px",
            },
        },
    },
    assessmentSwitchItem: {
        padding: theme.spacing(0.15, 0),
        borderBottom: "1px solid #eff0f2",
        marginBottom:"3px",
        '& .helpText': {
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            color: "#DF5151",
            padding: theme.spacing(1, 0),
            '& img': {
                marginRight: theme.spacing(1),
            },
        },
    },
    medicationsFormList: {
        padding: theme.spacing(5, 0),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(3, 0),
        },
        '& .headingSection': {
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
        '& .FormListItem': {
            justifyContent: "space-between",
            alignItems: "center",
            [theme.breakpoints.only("xs")]: {
                alignItems: "flex-start",
            },
            background: "#eff0f2",
            padding: theme.spacing(2.5, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(2.5, 3),
            },
            '& .MuiInputBase-formControl': {
                background: "#FFFFFF",
            },
            '& .removeBtn': {
                cursor: "pointer",
                textAlign: "center",
            },
            '& .HidehelpText': {
                display: "none",
                alignItems: "center",
                fontWeight: 400,
                color: "#00122A",
                padding: theme.spacing(1, 0),
                paddingRight:"10px",
                cursor: "pointer",
                '& img': {
                    marginRight: theme.spacing(1),
                },
                '& span': {
                    [theme.breakpoints.only("xs")]: {
                        display: "none",
                    },
                },
            },
            '& .ShowhelpText': {
                display: "flex",
                alignItems: "center",
                fontWeight: 400,
                color: "#00122A",
                padding: theme.spacing(1, 0),
                paddingRight:"10px",
                cursor: "pointer",
                '& img': {
                    marginRight: theme.spacing(1),
                },
                '& span': {
                    [theme.breakpoints.only("xs")]: {
                        display: "none",
                    },
                },
            },
            '& .errorFieldItem': {
                padding: theme.spacing(0.5, 0),
                paddingLeft: "40px",
                '& .MuiFormControlLabel-root': {
                    marginLeft: 0,
                    marginRight: 20,
                },
            },
        },
        '& .addButton': {
            marginTop: "20px",
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
    },
    notesFormList: {
        padding: theme.spacing(5, 0),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(3, 0),
        },
        '& .headingSection': {
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
        '& .FormListItem': {
            justifyContent: "space-between",
            alignItems: "flex-end",
            [theme.breakpoints.only("xs")]: {
                alignItems: "flex-start",
            },
            background: "#eff0f2",
            padding: theme.spacing(2.5, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(2.5, 3),
            },
            '& .MuiInputBase-formControl': {
                background: "#ffffff",
            },
            '& .removeBtn': {
                cursor: "pointer",
                textAlign: "center",              
            },
        },
        '& .addButton': {
            marginTop: "20px",
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
    },
    attachmentsFormList: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        overflow: 'hidden',
        backgroundColor: "#FFFFFF",
        //paddingBottom: theme.spacing(3),
        '& .gridList': {
            width: "100%",
            flexWrap: 'nowrap',
            transform: 'translateZ(0)',
            '& img.attachment': {
                width: "100%",
                //height: "100%",
            },
            '& .titleBar': {
                zIndex: 10,
                padding: theme.spacing(0, 2),
                background: "#6A7685",
                '& .wrap': {
                    margin: 0,
                },
                '& .title': {
                    color: "#FFFFFF",
                    fontSize: 14,
                    fontWeight: 600,
                },
                '& .removeBtn': {
                    cursor: "pointer",
                    //textAlign: "center",
                },
            },
        },
    },
    observationFormList: {
        padding: theme.spacing(5, 0),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(3, 0),
        },
        '& .headingSection': {
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
        '& .hintSection': {
            margin: 0,
            padding: theme.spacing(2, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(1, 3),
            },
            '& .hintItem': {
                '& .icon': {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "42px",
                    height: "42px",
                    marginBottom: theme.spacing(1),
                    '&.icon1': {
                        backgroundColor: "#F4C145",
                    },
                    '&.icon2': {
                        backgroundColor: "#D56C6A",
                    },
                    '& img': {
                        //
                    },
                },
                '& .content': {
                    '& .list': {
                        padding: theme.spacing(1, 0),
                        '& .title': {
                            fontSize: 15,
                            fontWeight: 800,
                            color: "#00122A",
                            marginBottom: 5,
                        },
                        '& ul': {
                            display: "block",
                            listStyleType: "disc",
                            listStylePosition: "outside",
                            padding: "0 0 0 5px",
                            margin: 0,
                            '& li': {
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#00122A",
                                marginLeft: "1em",
                                '&::marker': {
                                    fontSize: 20,
                                },
                            },
                        },
                    },
                },
            },
        },
        '& .printChartSection': {
            width: "1250px !important",
            //height:"2000px !important",
            "@supports (-webkit-touch-callout: none)":{
                transform:"scale(0.6)",
            },         
            '& .printChartContent': {
                fontFamily: "'Lato' !important",
                margin: 0,
                padding: "40px 60px 95px 60px",
                '& .printHeader': {
                    width: "1130px",
                    //display: "flex",
                    //alignItems: "flex-start",
                    //justifyContent: "space-between",
                    paddingBottom: "12px",
                    '& table': {
                        width: "100%",
                        border: 0,
                    },
                    '& .printLeft img': {
                        //height: "40px",
                    },
                    '& .printCenter': {
                        fontSize: "16px",
                        fontWeight: 400,
                        color: "#00142E",
                        paddingTop: "21px",
                    },
                    '& .printRight': {
                        textAlign: "right",
                        '& .titleSec': {
                            fontSize: "19px",
                            fontWeight: 900,
                            color: "#00142E",
                            paddingBottom: "4px",
                        },
                        '& .btn': {
                            display: "inline-block",
                            backgroundColor: "#AC1818",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            padding: "10px",
                            textDecoration: "none",
                            textTransform: "uppercase",
                            fontWeight: 900,
                            margin: 0,
                        },
                    },
                },
                '& .chartItem': {
                    width: "1130px",
                    padding: 0,
                    margin: 0,
                    '&.printBgl': {
                        padding: "25px 0px",
                    },
                    '& .gridContainer': {
                        //alignItems: "flex-start",
                        //justifyContent: "space-between",
                        padding: 0,
                        margin: 0,
                        '& .leftItem': {
                            width: "174px",
                            '& .title': {
                                fontSize: "18px",
                                fontWeight: 900,
                                color: "#00479D",
                                padding: 0,
                                margin: 0,
                                '& sub': {
                                    fontSize: "12px",
                                },
                            },
                            '& .hint': {
                                fontSize: "14px",
                                fontWeight: 400,
                                color: "#00142E",
                            },
                        },
                        '& .rightItem': {
                            //width: "calc(100% - 170px)",
                            width: "953px",
                        },
                    },
                },
            },
        },
        '& .formSection': {
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
        },
        '& .footerSection': {
            padding: theme.spacing(1, 0),
            '& .icon': {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50px",
                height: "50px",
                backgroundColor: "#00142E",
                borderRadius: "50px / 50px",
            },
            '& .text1': {
                fontSize: 16,
                fontWeight: 600,
                marginBottom:'18px',
                marginTop:'20px',
                color: "##00142E",
                paddingBottom: theme.spacing(2),
            },
           
              
            
        },
    },
    alteredTableList: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        overflow: 'hidden',
        backgroundColor: "#FFFFFF",
        padding: theme.spacing(2, 0),
        '& .headLabel': {
            fontSize: 14,
            marginBottom: theme.spacing(1.5),
        },
        '& .gridList': {
            width: "100%",
            flexWrap: 'nowrap',
            transform: 'translateZ(0)',
            '& .MuiOutlinedInput-adornedStart': {
                paddingLeft: theme.spacing(0),
            },
            '& .titleBar': {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
                width: "100%",
                backgroundColor: "#8B94A0",
                color: "#FFFFFF",
                fontSize: 14,
                fontWeight: 600,
                textTransform: "uppercase",
                textAlign: "center",
            },
            '& .footer': {
                fontSize: 14,
                textAlign: "center",
            },
            '& .icon': {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
                width: "30px",
            },
            '& .icon1': {
                backgroundColor: "#D56C6A",
            },
            '& .icon2': {
                backgroundColor: "#F4C145",
            },
            '& .icon3': {
                backgroundColor: "#80CBCE",
            },
        },
    },
    pcrDialog: {
        '& .MuiPaper-root': {
            //
        },
        '& .MuiDialogTitle-root': {
            fontSize: 14,
            fontWeight: 800,
            margin: 0,
            padding: theme.spacing(2.5),
            color: "#00142E",
            '& .MuiIconButton-root': {
                alignItems: "flex-start",
                padding: 0,
                margin: 0,
            },
            '& .closeButton': {
                cursor: "pointer",
                float: "right",
                padding: "4px 4px",
                '& img': {
                    height: "16px",
                    //marginTop: "4px",
                },
            },
            '& .button2': {
                cursor: "pointer",
                float: "right",
                marginRight: theme.spacing(3),
                padding: "0px 8px",
            },
        },
        '& .MuiDialogContent-root': {
            fontSize: 14,
            margin: 0,
            padding: theme.spacing(2.5),
        },
        '& .MuiDialogContent-dividers': {
            borderTopColor: "#F8F8F9",
            borderBottomColor: "#F8F8F9",
        },
    },
    acuitySelectionTab: {
        width: "100%",
        marginBottom: theme.spacing(2),
        '& .tabItem': {
            width: "50%",
            display: "inline-block",
            textAlign: "center",
            backgroundColor: "#EFF0F2",
            padding: theme.spacing(2, 0),
            margin: 0,
            fontSize: 14,
            fontWeight: 800,
            color: "#001430",
            cursor: "pointer",
            '&.selected': {
                borderBottom: "3px solid #001430",
            },
        },
    },
    acuityTab: {
        width: "100%",
        marginBottom: theme.spacing(2),
        '& .tabItem': {
            width: "100%",
            display: "inline-block",
            textAlign: "center",
            backgroundColor: "#EFF0F2",
            padding: theme.spacing(2, 0),
            margin: 0,
            fontSize: 14,
            fontWeight: 800,
            color: "#001430",
            cursor: "pointer",
            '&.selected': {
                borderBottom: "3px solid #001430",
            },
        },
    },
    acuitySelectionPopup: {
        minHeight: "100%",
        justifyContent: 'center',
        alignItems: "center",
        '& .header': {
            fontSize: 20,
            fontWeight: 900,
            padding: theme.spacing(0.7, 1.5),
            color: "#00142E",
            cursor: "pointer",
            background: "#eff0f2",
            '& .icon': {
                float: "right",
            },
            '&.high': {
                borderLeft: "8px solid #DF5151",
            },
            '&.medium': {
                borderLeft: "8px solid #F4C145",
            },
            '&.low': {
                borderLeft: "8px solid #B6BCC3",
            },
            '&.classB': {
                borderLeft: "8px solid #F2424A",
            },
            '&.classC': {
                borderLeft: "8px solid #FDBF11",
            },
            '&.classD': {
                borderLeft: "8px solid #00C5D1",
            },
            '&.classE': {
                borderLeft: "8px solid #B5BBC4",
            },
        },
        '& .body': {
            padding: theme.spacing(1.5),
            color: "#061933",
            '& .text1': {
                fontSize: 14,
                fontWeight: 800,
                marginLeft: "9px",
                //margin: theme.spacing(0.5, 0),
                
            },
            '& .text2': {
                fontSize: 14,
                fontWeight: 400,
                marginLeft: "12px",
                marginTop: theme.spacing(2),
                '& ul': {
                    display: "block",
                    listStyleType: "disc",
                    listStylePosition: "outside",
                    padding: 0,
                    margin: 0,
                    '& li': {
                        marginLeft: "1em",
                        paddingTop: 0,
                        '&::marker': {
                            fontSize: 20,
                        },
                    },
                },
            },
        },
    },
    pcrSubmitPopup: {
        '& .submitter': {
            fontSize: 14,
            fontWeight: 400,
            '& .name': {
                fontWeight: 600,
                marginBottom: theme.spacing(0.25),
            },
        },
        '& .MuiFormControlLabel-label': {
            fontSize: 14,
            fontWeight: 500,
        },
    },
    observationPopup: {
        '&.MuiDialogContent-root': {
            padding: 0,
            margin: 0,
            borderTop: "1px #D9D9D9 solid",
        },
        '& .MuiGrid-container.gridSection': {
            padding: theme.spacing(2.5, 5),
            borderTop: "1px #D9D9D9 solid",
            [theme.breakpoints.only("xs")]: {
                padding: theme.spacing(2.5, 2.5),
            },
            '&.buttons': {
                justifyContent: 'space-between',
                alignItems: "center",
                '& .MuiButton-root': {
                    width: "160px",
                    [theme.breakpoints.only("xs")]: {
                        width: "100%",
                    },
                },
            },
            '& .consciousness': {
                display: "flex",
                justifyContent: 'space-between',
                alignItems: "center",
                background: "#eff0f2",
                borderRadius: 4,
                '& .MuiIconButton-root': {
                    background: "#EFF0F2",
                    color: "#00142E",
                    fontSize: 14,
                    fontWeight: 700,
                    borderRadius: 4,
                    minWidth: 0,
                    width: "25%",
                    '&.selected': {
                        background: "#CACED4",
                    },
                },
            },
        },
    },
    ObservationChart: {
        //padding: theme.spacing(1, 0),
        '& .titleSection': {
            padding: theme.spacing(0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 3),
            },
            fontSize: "18px",
            fontWeight: 800,
            textTransform: "uppercase",
            '& span.hint': {
                display: "inline",
                fontSize: "15px",
                fontWeight: 500,
                marginTop: theme.spacing(0.5),            
                textTransform: "none",
                marginLeft:"15px",
                //marginLeft:"1000px"
                //float: "right",
            },
        },
        '& .graphSection': {
            padding: theme.spacing(0, 0, 0, 1),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 1),
            },
            height: "250px",
            //width: "auto",
        },
        '& .listSection': {
            padding: theme.spacing(0, 0, 0, 5),
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(0, 0, 0, 3),
            },
            margin: theme.spacing(2, 0),
            '& .gridList': {
                width: "100%",
                flexWrap: 'nowrap',
                backgroundColor: "#FFFFFF",
                border: "2px solid #CBCFD4",
                boxSizing: "border-box",
                '& .MuiGridListTile-tile': {
                    width: theme.spacing(9.5),
                    backgroundColor: "#FFFFFF",
                    border: "2px solid #0F213A",
                    boxSizing: "border-box",
                    padding: theme.spacing(0.3, 0),
                    margin: 0,
                    textAlign: "center",
                    cursor: "pointer",
                    '& .item': {
                        fontSize: "18px",
                        fontWeight: 700,
                        overflow: "hidden",
                    },
                },
            },
        },
    },
    helpText: {
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        fontWeight: 400,
        color: "#00122A",
        //padding: theme.spacing(1, 0),
        '& img': {
            marginRight: theme.spacing(1),
        },
    },
    painScoreDialog: {
        '& .MuiPaper-root': {
            //
        },
        '& .MuiDialogContent-root': {
            margin: 0,
            padding: theme.spacing(2.5),
            '& .mainSection': {
                '& .heading': {
                    fontSize: 20,
                    fontWeight: 800,
                    margin: 0,
                    padding: theme.spacing(3, 0),
                    color: "#001430",
                    textAlign: "center",
                },
                '& .body': {
                    padding: theme.spacing(3, 0),
                    minHeight: "calc(100vh - 248px)",
                    '& .bodyGrid': {
                        minHeight: "100%",
                        justifyContent: 'center',
                        alignItems: "center",
                        '& .scoreItem': {
                            display: "flex",
                            justifyContent: 'space-between',
                            alignItems: "center",
                            padding: theme.spacing(2),
                            marginBottom: theme.spacing(2),
                            //border: "2px solid black",
                            //borderTop: 0,
                            boxShadow: "0px 4px 6px #EEEEEE, 0px 0px 0px #FFFFFF",
                            borderRadius: "120px",
                            cursor: "pointer",
                            '& .iconSection': {
                                display: "inherit",
                                alignItems: "inherit",
                                gap: theme.spacing(2),
                                '& .icon svg': {
                                    //height: "80px",
                                },
                                '& .title': {
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: "#001430",
                                },
                            },
                            '& .scoreSection': {
                                '& .score': {
                                    fontSize: 18,
                                    fontWeight: 700,
                                    color: "#B0B7C0",
                                    padding: theme.spacing(0, 2),
                                },
                            },
                        },
                    },
                },
                '& .footer': {
                    padding: theme.spacing(3, 0),
                    borderTop: "2px solid #E9EAED",
                    '& .buttons': {
                        justifyContent: 'space-between',
                        alignItems: "center",
                    },
                },
            },
        },
    },
    autocomplete: {
        width: "100%",
        borderRadius: "4px",
        "& .clickable": {
            cursor: "pointer",
        },
        "& .MuiInputBase-root": {
            paddingTop: 4,
        },
    },
    autocompleteList: {
        margin: 0,
        background: "#fdfcfc",
        fontSize: 13,
    },
    autocompleteListOptions: {
        minHeight: "auto",
        alignItems: "flex-start",
        padding: 8,
        '&[data-focus="true"]': {
            backgroundColor: theme.palette.action.hover,
        },
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
}));